import { formatDefaultLocale } from 'd3-format';
import H from 'moment';
import 'moment/locale/de';
function B(n, ...t) {
  if (n == null) throw new TypeError("Cannot convert undefined or null to object");
  let e = Object(n);
  for (let i = 0; i < t.length; i++) {
    let r = t[i];
    if (r != null) for (let s in r) Object.prototype.hasOwnProperty.call(r, s) && (e[s] = r[s]);
  }
  return e;
}
function j(n, t) {
  return n === null || t === null ? n === t : typeof n != typeof t ? !1 : typeof n != "object" ? n === t : Array.isArray(n) && Array.isArray(t) ? $t(n, t) : !Array.isArray(n) && !Array.isArray(t) ? Ft(n, t) : !1;
}
function $t(n, t) {
  if (n.length !== t.length) return !1;
  for (let e = 0; e < n.length; e++) if (!j(n[e], t[e])) return !1;
  return !0;
}
function Ft(n, t) {
  let e = Object.keys(n),
    i = Object.keys(t);
  if (e.length !== i.length) return !1;
  for (let r of e) if (!i.includes(r) || !j(n[r], t[r])) return !1;
  return !0;
}
var I = class {
    constructor(t, e) {
      this.type = t, this.value = e;
    }
  },
  M = class {
    constructor(t, e) {
      this.type = t, this.value = e;
    }
  };
var S = `
`,
  Q = (r => (r.Ordered = "ordered", r.Bullet = "bullet", r.Checked = "checked", r.Unchecked = "unchecked", r))(Q || {}),
  J = (e => (e.Sub = "sub", e.Super = "super", e))(J || {}),
  pt = (t => (t.Rtl = "rtl", t))(pt || {}),
  dt = (r => (r.Left = "left", r.Center = "center", r.Right = "right", r.Justify = "justify", r))(dt || {}),
  U = (l => (l.Image = "image", l.Video = "video", l.Formula = "formula", l.Text = "text", l.InlineValue = "inlineValue", l.EChartsValue = "echartsValue", l.EmbedVisual = "embedVisual", l.InlineReference = "inlineReference", l.DynamicImage = "dynamicImage", l.DynamicLink = "dynamicLink", l.DynamicIframe = "dynamicIframe", l.CustomIframe = "customIframe", l))(U || {}),
  mt = (s => (s.Block = "block", s.InlineGroup = "inline-group", s.List = "list", s.Video = "video", s.Table = "table", s))(mt || {});
var G = class n {
  constructor(t, e) {
    typeof t == "string" && (t = new I("text", `${t}`)), this.insert = t, this.attributes = e || {};
  }
  static createNewLineOp() {
    return new n(S);
  }
  isContainerBlock() {
    return this.isBlockquote() || this.isList() || this.isTable() || this.isCodeBlock() || this.isHeader() || this.isBlockAttribute() || this.isCustomTextBlock();
  }
  isBlockAttribute() {
    let t = this.attributes;
    return !!(t.align || t.direction || t.indent || t.lineHeight);
  }
  isBlockquote() {
    return !!this.attributes.blockquote;
  }
  isHeader() {
    return !!this.attributes.header;
  }
  isTable() {
    return !!this.attributes.table;
  }
  isSameHeaderAs(t) {
    return t.attributes.header === this.attributes.header && this.isHeader();
  }
  hasSameAdiAs(t) {
    return this.attributes.align === t.attributes.align && this.attributes.direction === t.attributes.direction && this.attributes.indent === t.attributes.indent;
  }
  hasSameIndentationAs(t) {
    return this.attributes.indent === t.attributes.indent;
  }
  hasSameAttr(t) {
    return j(this.attributes, t.attributes);
  }
  hasHigherIndentThan(t) {
    return (Number(this.attributes.indent) || 0) > (Number(t.attributes.indent) || 0);
  }
  isInline() {
    return !(this.isContainerBlock() || this.isVideo() || this.isCustomEmbedBlock());
  }
  isCodeBlock() {
    return !!this.attributes["code-block"];
  }
  hasSameLangAs(t) {
    return this.attributes["code-block"] === t.attributes["code-block"];
  }
  isJustNewline() {
    return this.insert.value === S;
  }
  isList() {
    return this.isOrderedList() || this.isBulletList() || this.isCheckedList() || this.isUncheckedList();
  }
  isOrderedList() {
    return this.attributes.list === "ordered";
  }
  isBulletList() {
    return this.attributes.list === "bullet";
  }
  isCheckedList() {
    return this.attributes.list === "checked";
  }
  isUncheckedList() {
    return this.attributes.list === "unchecked";
  }
  isACheckList() {
    return this.attributes.list === "unchecked" || this.attributes.list === "checked";
  }
  isSameListAs(t) {
    return !!t.attributes.list && (this.attributes.list === t.attributes.list || t.isACheckList() && this.isACheckList());
  }
  isSameTableRowAs(t) {
    return !!t.isTable() && this.isTable() && this.attributes.table === t.attributes.table;
  }
  isText() {
    return this.insert.type === "text" || this.isInlineValue() || this.isInlineReference();
  }
  isImage() {
    return this.insert.type === "image";
  }
  isFormula() {
    return this.insert.type === "formula";
  }
  isVideo() {
    return this.insert.type === "video";
  }
  isIframe() {
    return this.insert.type === "customIframe";
  }
  isInlineValue() {
    return this.insert.type === "inlineValue";
  }
  isInlineReference() {
    return this.insert.type === "inlineReference";
  }
  isEmbedVisual() {
    return this.insert.type === "embedVisual";
  }
  isDynamicElement() {
    return this.insert.type === "dynamicImage" || this.insert.type === "dynamicLink" || this.insert.type === "dynamicIframe";
  }
  isLink() {
    return this.isText() && !!this.attributes.link;
  }
  isCustomEmbed() {
    return this.isInlineValue() || this.isInlineReference() || this.isEmbedVisual() || this.isDynamicElement();
  }
  isCustomEmbedBlock() {
    return this.isCustomEmbed() && !!this.attributes.renderAsBlock;
  }
  isCustomTextBlock() {
    return this.isText() && !!this.attributes.renderAsBlock;
  }
  isMentions() {
    return this.isText() && !!this.attributes.mentions;
  }
};
var W = class {
    constructor(t) {
      this.ops = t;
    }
  },
  Y = class {
    constructor(t) {
      this.op = t;
    }
  },
  v = class extends Y {},
  $ = class extends Y {},
  p = class {
    constructor(t, e) {
      this.op = t, this.ops = e;
    }
  },
  h = class {
    constructor(t) {
      this.items = t;
    }
  },
  z = class {
    constructor(t, e = null) {
      this.item = t, this.innerList = e;
    }
  },
  F = class {
    constructor(t) {
      this.rows = t;
    }
  },
  _ = class {
    constructor(t) {
      this.cells = t;
    }
  },
  N = class {
    constructor(t) {
      this.item = t;
    }
  };
function L(n, t = void 0) {
  if (!n) return "";
  let e = "";
  t && (e = [].concat(t).map(function (s) {
    return s.key + (s.value ? `="${s.value}"` : "");
  }).join(" "));
  let i = ">";
  return (n === "img" || n === "br") && (i = "/>"), e ? `<${n} ${e}${i}` : `<${n}${i}`;
}
function x(n = "") {
  return n && `</${n}>` || "";
}
function Ht(n) {
  return ft(0).reduce(kt, n);
}
function Z(n, t = !0) {
  return t && (n = Ht(n)), ft(0).reduce(Tt, n);
}
function yt(n) {
  let t = ft(1),
    e = t.reduce(kt, n);
  return t.reduce(Tt, e);
}
function ft(n) {
  let t = [["&", "&amp;"], ["<", "&lt;"], [">", "&gt;"], ['"', "&quot;"], ["'", "&#x27;"], ["\\/", "&#x2F;"], ["\\(", "&#40;"], ["\\)", "&#41;"]];
  return n === 0 ? t.filter(([e, i]) => e.indexOf("(") === -1 && e.indexOf(")") === -1) : t.filter(([e, i]) => e.indexOf("/") === -1);
}
function Tt(n, t) {
  return typeof n != "string" ? n : n.replace(new RegExp(t[0], "g"), t[1]);
}
function kt(n, t) {
  return typeof n != "string" ? n : n.replace(new RegExp(t[1], "g"), t[0].replace("\\", ""));
}
function X(n) {
  return n.length === 0 ? null : n.length >= 2 ? n[1] : n[0];
}
function V(n) {
  return n.reduce((t, e) => t.concat(Array.isArray(e) ? V(e) : e), []);
}
function It(n, t) {
  if (Array.prototype.find) return Array.prototype.find.call(n, t);
  for (let e = 0; e < n.length; e++) if (t(n[e])) return n[e];
}
function O(n, t) {
  let e = [],
    i,
    r;
  for (let s = 0; s < n.length; s++) i = n[s], s > 0 && t(i, n[s - 1]) ? (r = e[e.length - 1], r.push(i)) : e.push([i]);
  return e.map(s => s.length === 1 ? s[0] : s);
}
function ht(n, t, e) {
  let i = {
    elements: [],
    sliceStartsAt: -1
  };
  for (let r = t; r >= 0 && e(n[r]); r--) i.sliceStartsAt = r, i.elements.unshift(n[r]);
  return i;
}
function St(n) {
  let t = n;
  t = t.replace(/^\s*/gm, "");
  let e = /^((https?|s?ftp|file|blob|mailto|tel):|#|\/|data:image\/)/,
    i = /\.(jpe?g|gif|png|webp|svg)$/;
  return e.test(t) || i.test(t) ? t : `unsafe:${t}`;
}
var C = class {
  static sanitize(t, e) {
    let i = () => {};
    e && typeof e.urlSanitizer == "function" && (i = e.urlSanitizer);
    let r = i(t);
    return typeof r == "string" ? r : yt(St(t));
  }
};
var tt = class n {
  static sanitize(t, e) {
    let i = {};
    return !t || typeof t != "object" || (t.class && n.IsValidClass(t.class) && (i.class = t.class), t.id && n.IsValidId(t.id) && (i.id = t.id), n.IsValidTarget(`${t.target}`) && (i.target = t.target), t.avatar && (i.avatar = C.sanitize(`${t.avatar}`, e)), t["end-point"] && (i["end-point"] = C.sanitize(`${t["end-point"]}`, e)), t.slug && (i.slug = `${t.slug}`)), i;
  }
  static IsValidClass(t) {
    return !!t.match(/^[a-zA-Z0-9_\-]{1,500}$/i);
  }
  static IsValidId(t) {
    return !!t.match(/^[a-zA-Z0-9_\-\:\.]{1,500}$/i);
  }
  static IsValidTarget(t) {
    return ["_self", "_blank", "_parent", "_top"].indexOf(t) > -1;
  }
};
var w = class n {
  static sanitize(t, e) {
    let i = {};
    if (!t || typeof t != "object") return i;
    let r = ["bold", "italic", "underline", "strike", "code", "blockquote", "code-block", "renderAsBlock"],
      s = ["background", "color"],
      {
        font: o,
        size: a,
        link: u,
        script: c,
        list: d,
        header: g,
        align: l,
        direction: k,
        indent: f,
        mentions: A,
        mention: m,
        width: ot,
        weight: at,
        target: lt,
        rel: ut
      } = t,
      P = t["code-block"],
      vt = [...r, ...s, "font", "size", "link", "script", "list", "header", "align", "direction", "indent", "mentions", "mention", "width", "weight", "target", "rel", "code-block"];
    if (r.forEach(b => {
      let y = t[b];
      y && (i[b] = !!y);
    }), s.forEach(b => {
      let y = t[b];
      y && (n.IsValidHexColor(`${y}`) || n.IsValidColorLiteral(`${y}`) || n.IsValidRGBColor(`${y}`)) && (i[b] = y);
    }), o && n.IsValidFontName(`${o}`) && (i.font = o), a && n.IsValidSize(`${a}`) && (i.size = a), ot && n.IsValidWidth(`${ot}`) && (i.width = ot), at && n.IsValidFontWeight(`${at}`) && (i.weight = at), u && (i.link = C.sanitize(`${u}`, e)), lt && n.isValidTarget(lt) && (i.target = lt), ut && n.IsValidRel(ut) && (i.rel = ut), P && (n.IsValidLang(P) ? i["code-block"] = P : i["code-block"] = !!P), (c === "sub" || "super" === c) && (i.script = c), (d === "bullet" || d === "ordered" || d === "checked" || d === "unchecked") && (i.list = d), Number(g) && (i.header = Math.min(Number(g), 6)), It(["center", "right", "justify", "left"], b => b === l) && (i.align = l), k === "rtl" && (i.direction = k), f && Number(f) && (i.indent = Math.min(Number(f), 30)), A && m) {
      let b = tt.sanitize(m, e);
      Object.keys(b).length > 0 && (i.mentions = !!A, i.mention = m);
    }
    return Object.keys(t).reduce((b, y) => (vt.indexOf(y) === -1 && (b[y] = t[y]), b), i);
  }
  static IsValidHexColor(t) {
    return !!t.match(/^#([0-9A-F]{6}|[0-9A-F]{3})$/i);
  }
  static IsValidColorLiteral(t) {
    return !!t.match(/^[a-z]{1,50}$/i);
  }
  static IsValidRGBColor(t) {
    let e = /(#(?:[0-9a-f]{2}){2,4}|#[0-9a-f]{3}|(?:rgba?|hsla?)\((?:\d+%?(?:deg|rad|grad|turn)?(?:,|\s)+){2,3}[\s\/]*[\d\.]+%?\))/i;
    return !!t.match(e);
  }
  static IsValidFontName(t) {
    return !0;
  }
  static IsValidSize(t) {
    return !!t.match(/^[a-z0-9\-]{1,20}$/i);
  }
  static IsValidWidth(t) {
    return !!t.match(/^[0-9]*(px|em|%)?$/);
  }
  static IsValidFontWeight(t) {
    return !0;
  }
  static isValidTarget(t) {
    return !!t.match(/^[_a-zA-Z0-9\-]{1,50}$/);
  }
  static IsValidRel(t) {
    return !!t.match(/^[a-zA-Z\s\-]{1,250}$/i);
  }
  static IsValidLang(t) {
    return typeof t == "boolean" ? !0 : !!t.match(/^[a-zA-Z\s\-\\\/\+]{1,50}$/i);
  }
};
var Vt = {
    serif: "font-family: Georgia, Times New Roman, serif",
    monospace: "font-family: Monaco, Courier New, monospace"
  },
  Et = {
    font: n => Vt[n] || `font-family:${n.replace(/"/g, "'")}`,
    size: (n, t, e = 1) => `font-size:${+n.substring(0, n.indexOf("px")) * e}px`,
    fontStyle: n => `font-style:${n}`,
    weight: n => `font-weight:${n}`,
    textShadow: n => `text-shadow:${n}`,
    indent: (n, t) => {
      let e = parseInt(n, 10) * 3;
      return `padding-${t.attributes.direction === "rtl" ? "right" : "left"}:${e}em`;
    },
    lineHeight: n => `line-height:${n}`,
    direction: (n, t) => {
      if (n === "rtl") return `direction:rtl${t.attributes.align ? "" : "; text-align:inherit"}`;
    }
  },
  T = class {
    constructor(t, e) {
      this.op = t, this.options = B({}, {
        classPrefix: "ql",
        inlineStyles: void 0,
        encodeHtml: !0,
        listItemTag: "li",
        paragraphTag: "p",
        sizeFactor: 1
      }, e);
    }
    prefixClass(t) {
      return this.options.classPrefix ? `${this.options.classPrefix}-${t}` : `${t}`;
    }
    getHtml() {
      let t = this.getHtmlParts();
      return t.openingTag + t.content + t.closingTag;
    }
    getHtmlParts() {
      if (this.op.isJustNewline() && !this.op.isContainerBlock()) return {
        openingTag: "",
        closingTag: "",
        content: S
      };
      let t = this.getTags(),
        e = this.getTagAttributes();
      !t.length && e.length && t.push("span");
      let i = [],
        r = [],
        s = "img",
        o = a => a === s && !!this.op.attributes.link;
      for (let a of t) o(a) && i.push(L("a", this.getLinkAttrs())), i.push(L(a, e)), r.push(a === "img" ? "" : x(a)), o(a) && r.push(x("a")), e = [];
      return r.reverse(), {
        openingTag: i.join(""),
        content: this.getContent(),
        closingTag: r.join("")
      };
    }
    getContent() {
      if (this.op.isContainerBlock()) return "";
      if (this.op.isMentions()) return this.op.insert.value;
      let t = this.op.isFormula() || this.op.isText() ? this.op.insert.value : "";
      return this.options.encodeHtml && Z(t) || t;
    }
    getCssClasses() {
      let t = this.op.attributes;
      if (this.options.inlineStyles) return [];
      let e = ["indent", "align", "direction", "font", "size", "weight", "fontStyle"];
      return this.options.allowBackgroundClasses && e.push("background"), (this.getCustomCssClasses() || []).concat(e.filter(i => !!t[i]).filter(i => i === "background" ? w.IsValidColorLiteral(t[i]) : !0).map(i => `${i}-${t[i]}`).concat(this.op.isFormula() ? "formula" : []).concat(this.op.isVideo() ? "video" : []).concat(this.op.isImage() ? "image" : []).map(this.prefixClass.bind(this)));
    }
    getCssStyles() {
      let t = this.op.attributes,
        e = [["color"]];
      return (this.options.inlineStyles || !this.options.allowBackgroundClasses) && e.push(["background", "background-color"]), this.options.inlineStyles && (e = e.concat([["indent"], ["align", "text-align"], ["direction"], ["font", "font-family"], ["size", "font-size"], ["fontStyle", "font-style"], ["weight", "font-weight"], ["textShadow", "text-shadow"], ["contrastColorDark", "dark-color"], ["contrastColorLight", "light-color"], ["lineHeight", "line-height"]])), (this.getCustomCssStyles() || []).concat(e.filter(i => !!t[i[0]]).map(i => {
        let r = i[0],
          s = t[r],
          o = this.options.inlineStyles && this.options.inlineStyles[r] || Et[r];
        return typeof o == "object" ? o[s] : typeof o == "function" ? o(s, this.op, this.options.sizeFactor || 1) : `${X(i)}:${s}`;
      })).filter(i => i !== void 0);
    }
    getTagAttributes() {
      if (this.op.attributes.code && !this.op.isLink()) return [];
      let t = this.makeAttr.bind(this),
        e = this.getCustomTagAttributes(),
        i = e ? Object.keys(e).map(a => t(a, e[a])) : [],
        r = this.getCssClasses(),
        s = r.length ? i.concat([t("class", r.join(" "))]) : i;
      if (this.op.isImage()) {
        this.op.attributes.width && (s = s.concat(t("width", this.op.attributes.width)));
        let a = typeof this.options.escapeLink == "function" ? this.options.escapeLink(this.op.insert.value) : this.op.insert.value;
        return s.concat(t("src", a));
      }
      if (this.op.isACheckList()) return s.concat(t("data-checked", this.op.isCheckedList() ? "true" : "false"));
      if (this.op.isFormula()) return s;
      if (this.op.isVideo()) return s.concat(t("frameborder", "0"), t("allowfullscreen", "true"), t("src", this.op.insert.value));
      if (this.op.isIframe()) return s.concat(t("frameborder", "0"), t("allowfullscreen", "true"), t("src", this.op.insert.value.src), t("style", `width:${this.op.insert.value.width}`));
      if (this.op.isMentions()) {
        let a = this.op.attributes.mention;
        return a.class && (s = s.concat(t("class", a.class))), a["end-point"] && a.slug ? s = s.concat(t("href", `${a["end-point"]}/${a.slug}`)) : s = s.concat(t("href", "about:blank")), a.target && (s = s.concat(t("target", a.target))), s;
      }
      if (this.op.isEmbedVisual()) {
        let {
          value: a
        } = this.op.insert;
        return s.concat(t("data-joins", a.joins), t("data-node-id", a.nodeId), t("data-slug", a.slug));
      }
      let o = this.getCssStyles();
      return o.length && s.push(t("style", o.join(";"))), this.op.isCodeBlock() && typeof this.op.attributes["code-block"] == "string" ? s.concat(t("data-language", this.op.attributes["code-block"])) : (this.op.isContainerBlock() || this.op.isLink() && (s = s.concat(this.getLinkAttrs())), s);
    }
    makeAttr(t, e) {
      return {
        key: t,
        value: e
      };
    }
    getLinkAttrs() {
      let t = [],
        e = w.isValidTarget(this.options.linkTarget || "") ? this.options.linkTarget : void 0,
        i = w.IsValidRel(this.options.linkRel || "") ? this.options.linkRel : void 0,
        r = this.op.attributes.target || e,
        s = this.op.attributes.rel || i;
      return t.concat(this.makeAttr("href", this.op.attributes.link)).concat(r ? this.makeAttr("target", r) : []).concat(s ? this.makeAttr("rel", s) : []);
    }
    getCustomTag(t) {
      if (this.options.customTag && typeof this.options.customTag == "function") return this.options.customTag.apply(null, [t, this.op]);
    }
    getCustomTagAttributes() {
      if (this.options.customTagAttributes && typeof this.options.customTagAttributes == "function") return this.options.customTagAttributes.apply(null, [this.op]);
    }
    getCustomCssClasses() {
      if (this.options.customCssClasses && typeof this.options.customCssClasses == "function") {
        let t = this.options.customCssClasses.apply(null, [this.op]);
        if (t) return Array.isArray(t) ? t : [t];
      }
    }
    getCustomCssStyles() {
      if (this.options.customCssStyles && typeof this.options.customCssStyles == "function") {
        let t = this.options.customCssStyles.apply(null, [this.op]);
        if (t) return Array.isArray(t) ? t : [t];
      }
    }
    getTags() {
      let t = this.op.attributes;
      if (!this.op.isText()) return [this.op.isVideo() || this.op.isIframe() ? "iframe" : this.op.isImage() ? "img" : this.op.isEmbedVisual() ? this.op.insert.type : "span"];
      let e = this.options.paragraphTag || "p",
        i = [["blockquote"], ["code-block", "pre"], ["list", this.options.listItemTag], ["header"], ["align", e], ["lineHeight", e], ["direction", e], ["indent", e]];
      for (let o of i) {
        let a = o[0];
        if (t[a]) {
          let u = this.getCustomTag(a);
          return u ? [u] : a === "header" ? [`h${t[a]}`] : [X(o)];
        }
      }
      if (this.op.isCustomTextBlock()) {
        let o = this.getCustomTag("renderAsBlock");
        return o ? [o] : [e];
      }
      let r = Object.keys(t).reduce((o, a) => {
          let u = this.getCustomTag(a);
          return u && (o[a] = u), o;
        }, {}),
        s = [["link", "a"], ["mentions", "a"], ["script"], ["bold", "strong"], ["italic", "em"], ["strike", "s"], ["underline", "u"], ["code"]];
      return [...s.filter(o => !!t[o[0]]), ...Object.keys(r).filter(o => !s.some(a => a[0] === o)).map(o => [o, r[o]])].map(o => r[o[0]] ? r[o[0]] : o[0] === "script" ? t[o[0]] === "sub" ? "sub" : "sup" : X(o));
    }
  };
var E = class n {
  static pairOpsWithTheirBlock(t) {
    let e = [],
      i = a => !(a.isJustNewline() || a.isCustomEmbedBlock() || a.isVideo() || a.isContainerBlock()),
      r = a => a.isInline(),
      s = t.length - 1,
      o;
    for (let a = s; a >= 0; a--) {
      let u = t[a];
      u.isVideo() ? e.push(new v(u)) : u.isCustomEmbedBlock() ? e.push(new $(u)) : u.isContainerBlock() ? (o = ht(t, a - 1, i), e.push(new p(u, o.elements)), a = o.sliceStartsAt > -1 ? o.sliceStartsAt : a) : (o = ht(t, a - 1, r), e.push(new W(o.elements.concat(u))), a = o.sliceStartsAt > -1 ? o.sliceStartsAt : a);
    }
    return e.reverse(), e;
  }
  static groupConsecutiveSameStyleBlocks(t, e = {
    header: !0,
    codeBlocks: !0,
    blockquotes: !0,
    customBlocks: !0
  }) {
    return O(t, (i, r) => !(i instanceof p) || !(r instanceof p) ? !1 : e.codeBlocks && n.areBothCodeblocksWithSameLang(i, r) || e.blockquotes && n.areBothBlockquotesWithSameAdi(i, r) || e.header && n.areBothSameHeadersWithSameAdi(i, r) || e.customBlocks && n.areBothCustomBlockWithSameAttr(i, r));
  }
  static reduceConsecutiveSameStyleBlocksToOne(t) {
    let e = G.createNewLineOp();
    return t.map(function (i) {
      if (!Array.isArray(i)) return i instanceof p && !i.ops.length && i.ops.push(e), i;
      let r = i.length - 1;
      return i[0].ops = V(i.map((s, o) => s.ops.length ? s.ops.concat(o < r ? [e] : []) : [e])), i[0];
    });
  }
  static areBothCodeblocksWithSameLang(t, e) {
    return t.op.isCodeBlock() && e.op.isCodeBlock() && t.op.hasSameLangAs(e.op);
  }
  static areBothSameHeadersWithSameAdi(t, e) {
    return t.op.isSameHeaderAs(e.op) && t.op.hasSameAdiAs(e.op);
  }
  static areBothBlockquotesWithSameAdi(t, e) {
    return t.op.isBlockquote() && e.op.isBlockquote() && t.op.hasSameAdiAs(e.op);
  }
  static areBothCustomBlockWithSameAttr(t, e) {
    return t.op.isCustomTextBlock() && e.op.isCustomTextBlock() && t.op.hasSameAttr(e.op);
  }
};
var et = class {
  nest(t) {
    let e = this.convertListBlocksToListGroups(t),
      i = this.groupConsecutiveListGroups(e),
      r = V(i.map(o => Array.isArray(o) ? this.nestListSection(o) : o));
    return O(r, (o, a) => o instanceof h && a instanceof h ? o.items[0].item.op.isSameListAs(a.items[0].item.op) : !1).map(o => {
      if (!Array.isArray(o)) return o;
      let a = o.map(u => u.items);
      return new h(V(a));
    });
  }
  convertListBlocksToListGroups(t) {
    return O(t, (i, r) => i instanceof p && r instanceof p && i.op.isList() && r.op.isList() && i.op.isSameListAs(r.op) && i.op.hasSameIndentationAs(r.op)).map(i => Array.isArray(i) ? new h(i.map(r => new z(r))) : i instanceof p && i.op.isList() ? new h([new z(i)]) : i);
  }
  groupConsecutiveListGroups(t) {
    return O(t, (e, i) => e instanceof h && i instanceof h);
  }
  nestListSection(t) {
    let e = this.groupByIndent(t);
    return Object.keys(e).map(Number).sort().reverse().forEach(i => {
      e[i].forEach(r => {
        let s = t.indexOf(r);
        this.placeUnderParent(r, t.slice(0, s)) && t.splice(s, 1);
      });
    }), t;
  }
  groupByIndent(t) {
    return t.reduce((e, i) => {
      let r = i.items[0].item.op.attributes.indent;
      return r && (e[r] = e[r] || [], e[r].push(i)), e;
    }, {});
  }
  placeUnderParent(t, e) {
    for (let i = e.length - 1; i >= 0; i--) {
      let r = e[i];
      if (t.items[0].item.op.hasHigherIndentThan(r.items[0].item.op)) {
        let s = r.items[r.items.length - 1];
        return s.innerList ? s.innerList.items = s.innerList.items.concat(t.items) : s.innerList = t, !0;
      }
    }
    return !1;
  }
};
var nt = class {
  group(t) {
    return this.convertTableBlocksToTableGroups(t);
  }
  convertTableBlocksToTableGroups(t) {
    return O(t, (i, r) => i instanceof p && r instanceof p && i.op.isTable() && r.op.isTable()).map(i => Array.isArray(i) ? new F(this.convertTableBlocksToTableRows(i)) : i instanceof p && i.op.isTable() ? new F([new _([new N(i)])]) : i);
  }
  convertTableBlocksToTableRows(t) {
    return O(t, (i, r) => i instanceof p && r instanceof p && i.op.isTable() && r.op.isTable() && i.op.isSameTableRowAs(r.op)).map(i => new _(Array.isArray(i) ? i.map(r => new N(r)) : [new N(i)]));
  }
};
function Lt(n) {
  let t = `
`;
  if (n === t) return [n];
  let e = n.split(t);
  if (e.length === 1) return e;
  let i = e.length - 1;
  return e.reduce((r, s, o) => (o !== i ? s !== "" ? r = r.concat(s, t) : r.push(t) : s !== "" && r.push(s), r), []);
}
var it = class {
  static denormalize(t) {
    if (!t || typeof t != "object") return [];
    if (typeof t.insert == "object" || t.insert === S) return [t];
    let e = Lt(`${t.insert}`);
    if (e.length === 1) return [t];
    let i = B({}, t, {
      insert: S
    });
    return e.map(r => r === S ? i : B({}, t, {
      insert: r
    }));
  }
};
var R = class n {
  static convert(t, e) {
    if (!Array.isArray(t)) return [];
    let i = [],
      r = [];
    i = i.concat(...t.map(it.denormalize));
    let s, o;
    for (let a of i) a.insert && (s = n.convertInsertVal(a.insert, e), s && (o = w.sanitize(a.attributes, e), r.push(new G(s, o))));
    return r;
  }
  static convertInsertVal(t, e) {
    if (typeof t == "string") return new I("text", t);
    if (!t || typeof t != "object") return null;
    let i = Object.keys(t);
    return i.length ? "image" in t ? new I("image", C.sanitize(`${t.image}`, e)) : "video" in t ? new I("video", C.sanitize(`${t.video}`, e)) : "formula" in t ? new I("formula", t.formula) : new M(i[0], t[i[0]]) : null;
  }
};
var q = "<br/>",
  K = class {
    constructor(t, e) {
      this.rawDeltaOps = [];
      this.callbacks = {};
      this.options = B({
        paragraphTag: "p",
        encodeHtml: !0,
        classPrefix: "ql",
        inlineStyles: !1,
        multiLineBlockquote: !0,
        multiLineHeader: !0,
        multiLineCodeblock: !0,
        multiLineParagraph: !0,
        multiLineCustomBlock: !0,
        allowBackgroundClasses: !1,
        linkTarget: "_blank",
        sizeFactor: 1
      }, e, {
        orderedListTag: "ol",
        bulletListTag: "ul",
        listItemTag: "li"
      });
      let i;
      this.options.inlineStyles ? typeof this.options.inlineStyles == "object" ? i = this.options.inlineStyles : i = {} : i = void 0, this.converterOptions = {
        encodeHtml: this.options.encodeHtml,
        classPrefix: this.options.classPrefix,
        inlineStyles: i,
        listItemTag: this.options.listItemTag,
        paragraphTag: this.options.paragraphTag,
        linkRel: this.options.linkRel,
        linkTarget: this.options.linkTarget,
        allowBackgroundClasses: this.options.allowBackgroundClasses,
        customTag: this.options.customTag,
        customTagAttributes: this.options.customTagAttributes,
        customCssClasses: this.options.customCssClasses,
        customCssStyles: this.options.customCssStyles,
        sizeFactor: this.options.sizeFactor,
        escapeLink: this.options.escapeLink
      }, this.rawDeltaOps = t;
    }
    _getListTag(t) {
      return t.isOrderedList() ? `${this.options.orderedListTag}` : t.isBulletList() ? `${this.options.bulletListTag}` : t.isCheckedList() ? `${this.options.bulletListTag}` : t.isUncheckedList() ? `${this.options.bulletListTag}` : "";
    }
    getGroupedOps() {
      let t = R.convert(this.rawDeltaOps, this.options),
        e = E.pairOpsWithTheirBlock(t),
        i = E.groupConsecutiveSameStyleBlocks(e, {
          blockquotes: !!this.options.multiLineBlockquote,
          header: !!this.options.multiLineHeader,
          codeBlocks: !!this.options.multiLineCodeblock,
          customBlocks: !!this.options.multiLineCustomBlock
        }),
        r = E.reduceConsecutiveSameStyleBlocksToOne(i);
      return r = new nt().group(r), new et().nest(r);
    }
    convert() {
      return this.getGroupedOps().map(e => {
        if (e instanceof h) return this._renderWithCallbacks("list", e, () => this._renderList(e));
        if (e instanceof F) return this._renderWithCallbacks("table", e, () => this._renderTable(e));
        if (e instanceof p) {
          let i = e;
          return this._renderWithCallbacks("block", e, () => this._renderBlock(i.op, i.ops));
        } else return e instanceof $ ? this._renderCustom(e.op, null) : e instanceof v ? this._renderWithCallbacks("video", e, () => {
          let i = e;
          return new T(i.op, this.converterOptions).getHtml();
        }) : this._renderWithCallbacks("inline-group", e, () => this._renderInlines(e.ops, !0));
      }).join("");
    }
    _renderWithCallbacks(t, e, i) {
      let r = "",
        s = this.callbacks.beforeRender_cb;
      r = typeof s == "function" ? s.apply(null, [t, e]) : "", r || (r = i());
      let o = this.callbacks.afterRender_cb;
      return r = typeof o == "function" ? o.apply(null, [t, r]) : r, r;
    }
    _renderList(t) {
      let e = t.items[0];
      return L(this._getListTag(e.item.op)) + t.items.map(i => this._renderListItem(i)).join("") + x(this._getListTag(e.item.op));
    }
    _renderListItem(t) {
      t.item.op.attributes.indent = 0;
      let i = new T(t.item.op, this.converterOptions).getHtmlParts(),
        r = this._renderInlines(t.item.ops, !1);
      return i.openingTag + r + (t.innerList ? this._renderList(t.innerList) : "") + i.closingTag;
    }
    _renderTable(t) {
      return L("table") + L("tbody") + t.rows.map(e => this._renderTableRow(e)).join("") + x("tbody") + x("table");
    }
    _renderTableRow(t) {
      return L("tr") + t.cells.map(e => this._renderTableCell(e)).join("") + x("tr");
    }
    _renderTableCell(t) {
      let i = new T(t.item.op, this.converterOptions).getHtmlParts(),
        r = this._renderInlines(t.item.ops, !1);
      return L("td", {
        key: "data-row",
        value: t.item.op.attributes.table
      }) + i.openingTag + r + i.closingTag + x("td");
    }
    _renderBlock(t, e) {
      let r = new T(t, this.converterOptions).getHtmlParts();
      if (t.isCodeBlock()) return r.openingTag + Z(e.map(o => o.isCustomEmbed() ? this._renderCustom(o, t) : o.insert.value).join("")) + r.closingTag;
      let s = e.map(o => this._renderInline(o, t)).join("");
      return r.openingTag + (s || q) + r.closingTag;
    }
    _renderInlines(t, e = !0) {
      let i = t.length - 1,
        r = t.map((a, u) => u > 0 && u === i && a.isJustNewline() ? "" : this._renderInline(a, null)).join("");
      if (!e) return r;
      let s = L(this.options.paragraphTag),
        o = x(this.options.paragraphTag);
      return r === q || this.options.multiLineParagraph ? s + r + o : s + r.split(q).map(a => a === "" ? q : a).join(o + s) + o;
    }
    _renderInline(t, e) {
      return t.isCustomEmbed() ? this._renderCustom(t, e) : new T(t, this.converterOptions).getHtml().replace(/\n/g, q);
    }
    _renderCustom(t, e) {
      let i = this.callbacks.renderCustomOp_cb;
      return typeof i == "function" ? i.apply(null, [t, e]) : "";
    }
    beforeRender(t) {
      typeof t == "function" && (this.callbacks.beforeRender_cb = t);
    }
    afterRender(t) {
      typeof t == "function" && (this.callbacks.afterRender_cb = t);
    }
    renderCustomWith(t) {
      this.callbacks.renderCustomOp_cb = t;
    }
  };
var Mt = {
  monthsShort: ["Jan", "Feb", "M\xE4r", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"]
};
H.updateLocale("de", Mt);
var xt = (n, t, e = "de-DE", i = !0) => {
    e && !e.startsWith(H.locale()) && H.locale(e);
    let r = H.utc(n, t, i),
      s = t.toLowerCase();
    s.includes("w") && r.week() === 1 && (r = r.endOf("week").startOf("day"));
    let o = s === "hh:mm" || s.includes("d"),
      a = s === "yyyy" || s.includes("q") || s.includes("m");
    return !o && a && (r = r.add(1, "days")), r;
  },
  gt = (n, t, e = "de-DE") => (t.toLowerCase().includes("w") && (t = t.replace("YYYY", "GGGG")), n = H.isMoment(n) ? n : H(n), n.locale(e).format(t)),
  Ct = n => H(n).creationData().format;
var Wt = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"],
  _t = n => {
    let t = {
        decimal: ",",
        thousands: ".",
        grouping: [3],
        currency: ["", "\xA0\u20AC"]
      },
      e = {
        decimal: ".",
        thousands: ",",
        grouping: [3],
        currency: ["\xA3", ""]
      },
      i = {
        decimal: ".",
        thousands: ",",
        grouping: [3],
        currency: ["$", ""]
      };
    return n === "en-GB" ? e : n === "en-US" ? i : t;
  },
  qt = n => {
    let t = ["y", "z", "a", "f", "p", "nano", "mikro", "milli", "", " Tsd.", " Mio.", " Mrd.", " Bio.", " Brd.", " Tri.", " Trd.", " Qdi."],
      e = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "million", "billion", "trillion", "P", "E", "Z", "Y"];
    return n.includes("en") ? e : t;
  };
var bt = (n, t, e = !0, i = "de-DE") => {
    if (n == null) return "";
    if (!t) return n;
    let {
        formatType: r
      } = t,
      {
        date: s,
        number: o,
        locale: a,
        prefix: u,
        suffix: c
      } = t;
    if (r === void 0 && typeof n != "object") {
      let d = Ct(n);
      (typeof n == "number" || !isNaN(+n)) && (r = "number"), typeof n == "string" && d && (r = "date");
    }
    if (typeof n == "object" && n.constructor && n.constructor.name === "Date" && (r = "date"), r === "date" && s) {
      let {
        inputFormat: d,
        dateFormat: g
      } = s;
      typeof n == "object" ? n = gt(n, g, a) : (n = xt(n, d, i), n = gt(n, g, a));
    }
    if (r === "number" && !Number.isNaN(n)) {
      let {
          numberFormat: d,
          showSign: g
        } = o,
        l = formatDefaultLocale(_t(a)),
        k = d.match(/\.(\d)[~]?f/);
      k && k[1] > 0 && (n += Number.EPSILON * n), n === 0 && g && (d = d.replace("+", "-")), n = l.format(d)(n), n = Kt(n, a);
    }
    return e && (u && u.length > 0 && (n = u + n), c && c.length > 0 && (n = n + c)), n;
  },
  Kt = (n, t) => {
    let e = n.match(/[A-Za-z]/);
    if (e) {
      let i = Wt.indexOf(e[0]);
      n = n.replace(e[0], qt(t)[i]);
    }
    return n;
  };
var Pt = n => n ? `${n.x}px ${n.y}px ${n.blur}px ${n.color}` : "";
var wt = n => n ? typeof n == "string" ? n : `${n.value}` : "initial",
  Ot = (n, t = 1) => {
    let e = n.top * (n.topUnit !== "%" ? t : 1) + n.topUnit,
      i = n.right * (n.rightUnit !== "%" ? t : 1) + n.rightUnit,
      r = n.bottom * (n.bottomUnit !== "%" ? t : 1) + n.bottomUnit,
      s = n.left * (n.leftUnit !== "%" ? t : 1) + n.leftUnit;
    return `${e} ${i} ${r} ${s}`;
  };
var Dt = (n, t, e = "", i = 1, r) => {
    if (!n) return {};
    n.weight && typeof n.weight != "string" && console.log("!!! styleService font:", typeof n.weight, n);
    let s = {
      fontSize: `${n.size * i}px`,
      fontFamily: n.fontFamily,
      letterSpacing: `${n.letterSpacing || 0}px`,
      fontWeight: n.weight ? String(n.weight).replace("i", "") : "normal",
      textAlign: n.position === "auto" ? "center" : n.position,
      color: n.color,
      lineHeight: wt(n.lineheight),
      textShadow: Pt(n.shadow),
      margin: Ot(n.margin, i),
      padding: Ot(n.padding, i),
      fontStyle: n.fontStyle || "normal"
    };
    return s;
  },
  Qt = n => n.replace(/[A-Z]/g, t => `-${t.toLowerCase()}`),
  At = n => Object.entries(n).map(([i, r]) => `${Qt(i)}:${r}`).join(";");
var Jt = ["barchart", "horizontalbarchart", "donutchart", "parliamentchart", "piechart"],
  Yt = ["groupedbarchart", "stackedbarchart", "bar-grouped-horizontal", "bar-stacked-horizontal"],
  Zt = ["linechart", "areachart", "ttcharts-linechart"];
var Bt = (n, t) => !n || !t ? {} : Jt.includes(n) ? {
  labelField: t.find(e => e.dimName === "xAxis").fieldName,
  valueField: t.find(e => e.dimName === "yAxis").fieldName,
  aggregationField: void 0,
  timeField: void 0
} : Yt.includes(n) ? {
  labelField: t.find(e => e.dimName === "xAxis").fieldName,
  valueField: t.find(e => e.dimName === "yAxis").fieldName,
  aggregationField: t.find(e => e.dimName === "groupAxis").fieldName,
  timeField: void 0
} : Zt.includes(n) ? {
  timeField: t.find(e => e.dimName === "xAxis").fieldName,
  valueField: t.find(e => e.dimName === "yAxis").fieldName,
  labelField: t.find(e => e.dimName === "labelAxis").fieldName,
  aggregationField: t.find(e => e.dimName === "xAxis").fieldName
} : {};
var D = /*#__PURE__*/(() => {
  let D = class n {
    constructor(t) {
      this.resolveFields = (t, e = "No data available", i) => {
        let r = "",
          s = this.deltaOp.insert.value,
          {
            fieldName: o,
            format: a
          } = s;
        if (!this.fieldName || !t || t[this.fieldName] === void 0 || t[this.fieldName] === null) r = e;else {
          let u = "de-DE",
            c = i?.typeSpecific.fields[o];
          c && (u = c.format.locale), r = bt(t[this.fieldName], a, !0, u);
        }
        return r;
      };
      this.deltaOp = t, this.fieldName = t.insert?.value?.fieldName;
    }
    static {
      this.create = t => new n(t);
    }
  };
  return D;
})();
var rt = /*#__PURE__*/(() => {
  let rt = class n extends D {
    constructor() {
      super(...arguments);
      this.resolveFieldsReference = (e, i = "No data available", r) => {
        let s = this.deltaOp.insert.value,
          {
            fieldType: o
          } = s,
          a = Bt(r.type, r?.typeSpecific?.dimensions);
        return this.fieldName = a[o], this.resolveFields(e, i);
      };
    }
    static {
      this.create = e => new n(e);
    }
  };
  return rt;
})();
function Xt(n, t, e, i = 1, r, s = {}) {
  let o = l => {
      try {
        if (l.insert.type === "inlineValue") {
          let f = new T(l, {
              inlineStyles: !0,
              sizeFactor: i
            }).getHtml(),
            m = D.create(l).resolveFields(e, "", r);
          return m = m.replace(/-/g, "&#8209;"), f.replace("[object Object]", m);
        } else if (l.insert.type === "inlineReference") {
          let f = new T(l, {
              inlineStyles: !0,
              sizeFactor: i
            }).getHtml(),
            m = rt.create(l).resolveFieldsReference(e, "", r);
          return m = m.replace(/-/g, "&#8209;"), f.replace("[object Object]", m);
        } else return "Unmanaged custom blot!";
      } catch (k) {
        return console.log("[QuillDeltaToHtmlConverter] error:", k), "Error in custom blot!";
      }
    },
    a = Dt(t);
  delete a.color;
  let u = At({
      ...a,
      ...s
    }),
    c = {
      ops: []
    };
  typeof n == "string" && (c = JSON.parse(n));
  let d = new K(c.ops, {
    inlineStyles: !0,
    sizeFactor: i
  });
  return d.renderCustomWith(o), `<div style="${u}">${d.convert()}</div>`;
}
var st = /*#__PURE__*/(() => {
  let st = class n {
    constructor(t) {
      this.deltaOp = t, this.fieldName = t.insert?.value?.fieldName;
    }
    static {
      this.create = t => new n(t);
    }
  };
  return st;
})();
var te = (n, t, e, i = 1, r, s = {}) => {
    let o = JSON.parse(n),
      a = R.convert(o.ops, {}),
      u = {},
      c = [],
      d = Gt(t, i),
      g = 0;
    for (let l of a) {
      if (!["echartsValue", "inlineValue", "text"].includes(l.insert.type)) continue;
      let k = s.align ? {
        ...l.attributes,
        ...s
      } : l.attributes;
      u[`style${g}`] = {
        ...d,
        ...Gt(k, i)
      };
      let f = `style${g}`;
      if (g++, l.insert.type === "text") switch (l.insert.value) {
        case `
`:
          c.push(`{${f}|
}`);
          break;
        case "	":
          c.push(`{${f}|	}`);
          break;
        default:
          c.push(`{${f}|${l.insert.value}}`);
          break;
      } else if (l.insert.type === "inlineValue") {
        let m = D.create(l).resolveFields(e, "", r);
        m = m.replace(/-/g, "&#8209;"), c.push(`{${f}|${m}}`);
      } else if (l.insert.type === "echartsValue") {
        let A = st.create(l);
        c.push(`{${f}|{${A.fieldName}}}`);
      }
    }
    return {
      formatter: c.join(""),
      rich: u
    };
  },
  Gt = (n, t = 1) => {
    let e = {
      ...n
    };
    return e.background && (e.backgroundColor = n.background, delete e.background), e.font && (e.fontFamily = e.font, delete e.font), e.size && (e.fontSize = Number.parseFloat(e.size) * t, delete e.size), e.padding && (e.padding = [e.padding.top, e.padding.right, e.padding.bottom, e.padding.left]), e.position && (e.align = e.position, delete e.position), e.weight && (e.fontWeight = e.weight, delete e.weight), e.shadow && (e.textShadowColor = e.shadow.color, e.textShadowBlur = e.shadow.blur, e.textShadowOffsetX = e.shadow.x, e.textShadowOffsetY = e.shadow.y, delete e.shadow), e.lineheight && (e.lineHeight = (e.lineheight.value === "initial" ? 1 : e.lineheight.value) * e.fontSize, delete e.lineheight), e.enabled && delete e.enabled, e.margin && delete e.margin, e.position && delete e.position, e;
  };
export { dt as AlignType, p as BlockGroup, $ as BlotBlock, U as DataType, G as DeltaInsertOp, pt as DirectionType, mt as GroupType, W as InlineGroup, M as InsertDataCustom, I as InsertDataQuill, h as ListGroup, z as ListItem, Q as ListType, S as NewLine, T as OpToHtmlConverter, K as QuillDeltaToHtmlConverter, J as ScriptType, v as VideoItem, Xt as convertDeltaToHTML, te as convertDeltaToRich, bt as formatField };

